import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicAnnouncement } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const getActiveAnnouncements = async (
  orgId: string,
): Promise<PublicAnnouncement[]> => {
  const response = await axiosClient.get(`${orgId}/announcements/active`);
  return response.data;
};

export function activeAnnouncementsQueryKey(orgId: string) {
  return ["active-announcements", orgId];
}

export function useGetActiveAnnouncements(
  orgId: string,
  queryOptions?: Partial<UseQueryOptions<PublicAnnouncement[], HttpError>>,
) {
  return useQuery({
    queryKey: activeAnnouncementsQueryKey(orgId),
    queryFn: () => getActiveAnnouncements(orgId),
    ...queryOptions,
  });
}
